import React from 'react';
import './GuestGuideLoadState.css';

const text = {
  ko: {
    loading: '최신 안내문을 불러오는 중입니다.',
    error: '최신 안내문을 불러오지 못했습니다. 연결을 확인하고 다시 시도해 주세요.',
    retry: '다시 시도',
  },
  en: {
    loading: 'Loading the latest guidelines…',
    error: 'Unable to load the latest guidelines. Check your connection and try again.',
    retry: 'Try again',
  },
  fr: {
    loading: 'Chargement du guide à jour…',
    error: 'Impossible de charger le guide à jour. Vérifiez votre connexion et réessayez.',
    retry: 'Réessayer',
  },
};

export default function GuestGuideLoadState({ language, loading, retry }) {
  const labels = text[language] || text.en;
  return (
    <div className="guest-guide-load-state" role={loading ? 'status' : 'alert'}>
      <p>{loading ? labels.loading : labels.error}</p>
      {!loading && <button type="button" onClick={retry}>{labels.retry}</button>}
    </div>
  );
}
